import React, { useMemo } from "react"
import { formatOpeningHours } from "../../../../helpers/IsoDateHelpers"
import * as SelectionFactoryHelper from "../../../helpers/SelectionFactoryHelper"

const MerchantPageHero = ({
  alwaysOpen,
  mondayOpening,
  mondayClosing,
  tuesdayOpening,
  tuesdayClosing,
  wednesdayOpening,
  wednesdayClosing,
  thursdayOpening,
  thursdayClosing,
  fridayOpening,
  fridayClosing,
  saturdayOpening,
  saturdayClosing,
  sundayOpening,
  sundayClosing,
  heroColorMain,
  heroColorOpeningHours,
  chooseDescription,
  descriptionShort,
  description,
  customCategoryLabel,
  categoriesText,
  categories,
  pageTitle,
  customLocationLabel,
  webLogoUpload,
  webLogo,
  weekdays,
  merchantPageLabels,
  alwaysOpenText,
  closedLabel,
}) => {
  const lang = (document.body && document.body.dataset.language) || "da"

  const openingHours = useMemo(() => {
    return !alwaysOpen
      ? [
          { open: formatOpeningHours(mondayOpening, lang), close: formatOpeningHours(mondayClosing, lang) },
          { open: formatOpeningHours(tuesdayOpening, lang), close: formatOpeningHours(tuesdayClosing, lang) },
          { open: formatOpeningHours(wednesdayOpening, lang), close: formatOpeningHours(wednesdayClosing, lang) },
          { open: formatOpeningHours(thursdayOpening, lang), close: formatOpeningHours(thursdayClosing, lang) },
          { open: formatOpeningHours(fridayOpening, lang), close: formatOpeningHours(fridayClosing, lang) },
          { open: formatOpeningHours(saturdayOpening, lang), close: formatOpeningHours(saturdayClosing, lang) },
          { open: formatOpeningHours(sundayOpening, lang), close: formatOpeningHours(sundayClosing, lang) },
        ]
      : [7].map(() => ({ open: "", close: "" }))
  }, [
    alwaysOpen,
    mondayOpening,
    mondayClosing,
    tuesdayOpening,
    tuesdayClosing,
    wednesdayOpening,
    wednesdayClosing,
    thursdayOpening,
    thursdayClosing,
    fridayOpening,
    fridayClosing,
    saturdayOpening,
    saturdayClosing,
    sundayOpening,
    sundayClosing,
    lang,
  ])

  const formatDayOfWeek = (weekday) => {
    const lang = document?.body?.dataset?.language || "da"

    if (lang === "en" && weekday.length > 3) weekday = weekday.substring(0, 3) + "."

    return weekday
  }

  const heroColor = SelectionFactoryHelper.getFromSelectionFactory(heroColorMain) || ""
  const openingHoursColor = SelectionFactoryHelper.getFromSelectionFactory(heroColorOpeningHours) || ""
  const descriptionChoice = SelectionFactoryHelper.getFromSelectionFactory(chooseDescription)
  const descriptionText = descriptionChoice === "Short" ? descriptionShort : description

  return (
    <React.Fragment>
      <div className={`shoppage__hero ${heroColor}`}>
        <div className="shoppage__hero__content">
          <div className="category">{customCategoryLabel ?? (categoriesText?.join(", ") || categories?.join(", "))}</div>
          <h1 data-epi-edit="PageTitle">{customLocationLabel ? `${pageTitle} ${customLocationLabel}` : pageTitle}</h1>
          <div className="maintext" data-epi-edit={descriptionChoice === "Short" ? "Description" : "DescriptionShort"}>
            {descriptionText}
          </div>
          <div className="logo">
            <img src={webLogoUpload ?? webLogo} data-epi-edit="WebLogo" loading="eager" fetchPriority="high" />
          </div>
          <div className="clear"></div>
        </div>
      </div>
      <div className={`shoppage__openinghours ${openingHoursColor}`}>
        <div className="minimum-width">
          <ul>
            {openingHours.map((hours, index) => {
              let day = weekdays[index]

              let displayText

              if (alwaysOpen) {
                displayText = alwaysOpenText ?? merchantPageLabels.alwaysOpenText
              } else if (hours.open === "" && hours.close === "") {
                displayText = closedLabel ?? merchantPageLabels?.closedLabel
              } else {
                displayText = (
                  <>
                    {hours.open} - <br />
                    {hours.close}
                  </>
                )
              }

              return (
                <li key={day}>
                  <div>{formatDayOfWeek(day)}</div>
                  {displayText}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </React.Fragment>
  )
}

export default MerchantPageHero
